export const nitrileGlovesSpecifications = [
    {
        heading: "Premium Nitrile Disposable Gloves",
        description: "Rubber and powder free gloves for sensitive hands or foods, high quality disposable gloves designed for professional use to keep your hands protected. With enhanced strength and tear resistance, they offer unmatched reliability.",
        features: []
    },
    {
        heading: "Latex & Powder Free Nitrile Gloves",
        description: "Avoid potential allergies and discomfort with our gloves – without the use of latex or powder, your body will be kept in optimal safety from potential allergens. Nitrile gloves protect against viruses isolate the virus and prevent exposure.",
        features: []
    },
    {
        heading: "Textured Design",
        description: "Textured design provides a confident, non-slip grip. Nitrile gloves are developed for extended-duration use and will protect against grease, pesticides, gasoline, and a long list of specialty chemicals. Ultimate value and incredible toughness, these Nitrile disposable gloves are suited for use in many settings.",
        features: []
    },
    {
        heading: "Multifunctional",
        description: "Nitrile disposable gloves can be optimally utilized in medical facilities, laboratories, printing plants, beauty salons, food services, vehicle maintenance shops, environmental protection, dust-free workshops, general cleaning purposes, public places, outdoors and more.",
        features: []
    }
]; 